import { gql } from '@apollo/client';
import { CHAT_BANNER_DTO } from '@api/fragment/chapters';
import {
  BADGE_DTO,
  CHAT_ONBOARDING_POPUPS,
  CHAT_STORY_DTO,
} from '@api/fragment/story';

// 타입 확인은 useGetChapter.ts파일에서 가능합니다.
// 필드 추가 & 타입 추가 시 반드시 타입 확인 후 추가해주세요
export const GET_CHAT_CHAPTER = gql`
  query GetChatChapter($chapterId: Int!) {
    chapter: getChapter(data: { id: $chapterId }) {
      chapterId
      storyId
      name
      chapterIndex
      chapterScript
      hasBGM
      storyId
      chapterId
      chapterIndex
      name
      freedAt
      freeDependencyChapterIndex
      price
      isAdult
      onboardingPopups {
        ...ChatOnboardingPopups
      }
      story {
        ...ChatStoryDto
      }
      chapterOption {
        ...ChatBannerDto
      }
    }
  }
  ${CHAT_ONBOARDING_POPUPS}
  ${CHAT_STORY_DTO}
  ${CHAT_BANNER_DTO}
`;

export const GET_AD_INFO = gql`
  query GetAdInfo($storyId: Int!, $chapterId: Int!) {
    user: getUser {
      isPremium
    }
    story: getStoryV3(data: { id: $storyId }) {
      purchasable
      lastPlay {
        playedChapters {
          chapterId
          ending {
            name
            endingId
            chapterId
          }
        }
      }
    }
    chapter: getChapter(data: { id: $chapterId }) {
      freedAt
      freeDependencyChapterIndex
      freeDependencyPeriod
      remainingTimeToFree
      chapterIndex
    }
  }
`;

export const LIST_ACHIEVEMENTS = gql`
  query ListAchievements($storyId: Int!) {
    listAchievements(data: { storyId: $storyId }) {
      list {
        ...BadgeDto
      }
      totalCount
      page
      pageSize
    }
  }
  ${BADGE_DTO}
`;

export const GET_REMOTE_SCRIPT_STATEMENTS = gql`
  query GetRemoteScriptStatements(
    $provider: String!
    $remoteScriptType: REMOTE_SCRIPT_TYPE!
    $chapterId: Int!
    $remoteScriptId: String!
    $params: [String!]
    $background: String
  ) {
    getRemoteScriptStatements(
      data: {
        provider: $provider
        remoteScriptType: $remoteScriptType
        chapterId: $chapterId
        remoteScriptId: $remoteScriptId
        params: $params
        background: $background
      }
    ) {
      statements
    }
  }
`;

export const GET_CURRENT_PROPS = gql`
  query GetCurrenrProps($storyId: Int!) {
    getStoryV3(data: { id: $storyId }) {
      lastPlay {
        currentPlayingChapter {
          currentProps
        }
      }
    }
  }
`;

export const STORY_GAME_SERVER = gql`
  query StoryGameServer($chapterId: Int!) {
    getChapter(data: { id: $chapterId }) {
      story {
        playType
      }
    }
  }
`;
